import type { ICockpitKeyInitiative, ICockpitMdfActivity } from '../model/types'

interface IParams {
  initiatives: ICockpitKeyInitiative[]
  mdfActivities: ICockpitMdfActivity[]
  /** `null` leaves the single-partner cockpit data unrestricted. */
  partnerIds: string[] | null
}

export const getCockpitKeyInitiativesDataForPartners = ({
  initiatives,
  mdfActivities,
  partnerIds,
}: IParams) => {
  if (partnerIds === null) {
    return { initiatives, mdfActivities }
  }

  const partnerIdSet = new Set(partnerIds)

  return {
    initiatives: initiatives.filter(({ PartnerId }) => partnerIdSet.has(PartnerId)),
    mdfActivities: mdfActivities.filter(({ partnerId }) => partnerIdSet.has(partnerId)),
  }
}
